import { render, staticRenderFns } from "./panel-form.vue?vue&type=template&id=6b3277e5&"
import script from "./panel-form.vue?vue&type=script&lang=js&"
export * from "./panel-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports